import {
  callSaradiumBackend,
} from "../../lib/appwrite";

import type {
  CreateEventCircleInput,
  EventCircle,
  EventCircleDashboard,
  EventCircleResponse,
  UpdateEventCircleInput,
} from "./eventCircle.types";

function normaliseCircle(
  value: Partial<EventCircle>,
): EventCircle {
  return {
    circleId: String(value.circleId || ""),
    title: String(value.title || ""),
    description: String(value.description || ""),
    location: String(value.location || ""),
    startsAt: Number(value.startsAt || 0),
    endsAt: Number(value.endsAt || 0),

    visibility:
      value.visibility === "PUBLIC"
        ? "PUBLIC"
        : "PRIVATE",

    status:
      value.status === "CANCELLED"
        ? "CANCELLED"
        : "ACTIVE",

    editCount: Number(value.editCount || 0),

    updatedAt: Number(value.updatedAt || 0),

    isHost: Boolean(value.isHost),

    responseStatus:
      value.responseStatus || "AWAITING",

    shareable: Boolean(value.shareable),

    token: value.token,

    invitationId: value.invitationId,
  };
}

export async function listMyEventCircles(): Promise<
  EventCircle[]
> {
  const result =
    await callSaradiumBackend<{
      circles?: Partial<EventCircle>[];
    }>({
      action: "listMyEventCircles",
    });

  return (result.circles || []).map(
    normaliseCircle,
  );
}

export async function createEventCircle(
  input: CreateEventCircleInput,
): Promise<EventCircle> {
  const result =
    await callSaradiumBackend<
      Partial<EventCircle>
    >({
      action: "createEventCircleInvitation",
      ...input,
    });

  return normaliseCircle(result);
}

export async function getEventCircleDashboard(
  circleId: string,
): Promise<EventCircleDashboard> {
  const result =
    await callSaradiumBackend<
      Partial<EventCircleDashboard>
    >({
      action: "getEventCircleDashboard",
      circleId,
    });

  return {
    ...normaliseCircle(result),

    going: Number(result.going || 0),

    maybe: Number(result.maybe || 0),

    busy: Number(result.busy || 0),

    notGoing: Number(result.notGoing || 0),

    awaiting: Number(result.awaiting || 0),
  };
}

export async function updateEventCircle(
  input: UpdateEventCircleInput,
): Promise<EventCircle> {
  const result =
    await callSaradiumBackend<
      Partial<EventCircle>
    >({
      action: "updateEventCircle",
      ...input,
    });

  return normaliseCircle(result);
}

export async function cancelEventCircle(
  circleId: string,
): Promise<EventCircle> {
  const result =
    await callSaradiumBackend<
      Partial<EventCircle>
    >({
      action: "cancelEventCircle",
      circleId,
    });

  return normaliseCircle(result);
}

export async function respondToEventCircle(
  token: string,
  status: EventCircleResponse,
): Promise<EventCircle> {
  const result =
    await callSaradiumBackend<
      Partial<EventCircle>
    >({
      action: "respondToEventCircle",
      token,
      status,
    });

  return normaliseCircle(result);
}

export async function getEventCircleInvitation(
  token: string,
): Promise<EventCircle> {
  const result =
    await callSaradiumBackend<
      Partial<EventCircle>
    >({
      action: "getEventCircleInvitation",
      token,
    });

  return normaliseCircle(result);
}